import React from 'react';

export default function CloseIcon(props: any) {
  return (
    <span {...props}>
      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M23 1L1 23M1 1l22 22" />
      </svg>
    </span>
  );
}
